/**
 * Child roster → general whose character ultimate applies (MvM / PvP UI).
 * Standalone module (no imports) so lazy-loaded chunks never see a partial `allianceCombat` export.
 * Keep aligned with backend `CHILD_CHARACTER_ULTIMATE_SOURCE` in `pvpUltimateAbilities.js`.
 */
export const CHILD_CHARACTER_ULTIMATE_SOURCE: Record<string, string> = {
  astrae: 'motoko',
  aurelyn: 'motoko',
  caladros: 'vitalis',
  draxis: 'solvarion',
  elowyn: 'caeloria',
  elyndra: 'solvarion',
  enlyndra: 'solvarion',
  kaedor: 'bruxus',
  kaelithra: 'korthas',
  kai: 'nytheris',
  lorcan: 'hayate',
  morvessa: 'bula',
  nyrelle: 'finza',
  orienth: 'valyra',
  orineth: 'valyra',
  rexor: 'solvarion',
  saelis: 'korthas',
  seraphae: 'caeloria',
  silmera: 'rena',
  tharion: 'archera',
  vaelor: 'sakura',
  vireya: 'nytheris',
}

export function resolveUltimateAbilityCharacterId(characterId: string): string {
  const id = (characterId || '').toLowerCase().trim()
  return CHILD_CHARACTER_ULTIMATE_SOURCE[id] ?? id
}
